import React, { useState, useCallback, useEffect } from "react";
import {
  BackNextButton,
  AddButton,
  Button,
  EditCard,
  Modal,
  LoadingIcon,
} from "../../../../../common";
import { Search } from "./Search";
import { AddCompanyName } from "./AddCompanyName";
import useSearchCompany from "../../../../../../Hooks/useSearchCompany";

import { getCountryByCode } from "../../../../../../utils/Helper";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as TypeIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/type.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { ReactComponent as NationalityIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/nationality.svg";
import { ReactComponent as ShareIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/share.svg";
import { EditCardItems } from "../EditCardItems";
import { AddNewOwner } from "./AddNewOwnerForm";
import {
  useGetCompanyQuery, useCreateOwnershipDraftFetchMutation, useUpdateOwnershipCompanyDetailsMutation, useUpdateOwnershipIndividualMutation, useDeleteOwnershipCompanyDetailsMutation, useDeleteOwnershipCompDraftMutation,
  useDeleteOwnershipIndDraftMutation
} from "../../../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";

import CreditNotice from "../../../../../../assets/images/getthecompany.svg";
import bgImage from "../../../../../../assets/images/bg-layer.jpg";
import { ReactComponent as Close } from "../../../../../../assets/icons/close2.svg";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const OwnershipStructure = ({ onPrev, onNext, onSkip, handleUpdateStatus, compRefetch }) => {
  const dispatch = useDispatch();
  const [ownershipCompany, setOwnershipCompany] = useState([]);
  const [OwnershipCompanyDraft, setOwnershipCompanyDraft] = useState([]);
  const [totalPercentage, settotalPercentage] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [editOwnership, setEditOwnership] = useState(null);
  const [previsousShare, setprevisousShare] = useState(null);
  const [previsousCountry, setprevisousCountry] = useState(null);
  const [dataChanged, setDataChanged] = useState(false);

  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const [ownershipDraft] = useCreateOwnershipDraftFetchMutation();
  const [showSearch, setShowSearch] = useState(false);
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [countryCodeSearch, setCountryCodeSearch] = useState("");
  const [deleteDraftOwnership] = useDeleteOwnershipIndDraftMutation()
  const [deleteDraftCompany] = useDeleteOwnershipCompDraftMutation()
  const [updateOwnershipIndividual] = useUpdateOwnershipIndividualMutation();
  const [updateOwnershipCompanyDetails] = useUpdateOwnershipCompanyDetailsMutation();

  const [showModal, setShowModal] = useState(false);
  const [deleteOwnershipCompanyDetails] = useDeleteOwnershipCompanyDetailsMutation();

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const { worldBoxToken } = useSelector((state) => state.search);
  const { data: searchdata, isLoading: isLoadingSearch, error, message } = useSearchCompany(
    searchQuery,
    countryCodeSearch,
    token,
    worldBoxToken
  );
  useEffect(() => {
    if (searchdata) {
      setSearchResults(searchdata);
    }
  }, [searchdata]);
  const { data, isLoading, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });
  function searchCompany(fn, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        fn.apply(context, args);
      }, wait);
    };
  }
  const handleAddNewCompany = () => {
    setShowAddCompany((prev) => !prev);
    setShowSearch((prev) => !prev);
    setSearchResults([]);
    setSelectedCompany(null);
    setSearchQuery("");
  };
  const searchOnChange = useCallback(searchCompany(setSearchQuery, 400), []);
  useEffect(() => {
    if (data) {
      dispatch(setCurrentEditingCompany(data));
    }
  }, [data, dispatch, isOpen, dataChanged]);

  useEffect(() => {
    if (!currentEditingCompany || !data) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.ownershipCompany?.forEach(function (obj) {
      if (obj?.ownershipID?.ownership_indID?.is_deleted == 0 && obj?.ownershipID?.ownership_compID == null) {
        resultArr.push(obj)
      }
      else if (obj?.ownershipID?.ownership_compID?.is_deleted == 0 && obj?.ownershipID?.ownership_indID == null) {
        resultArr.push(obj)
      }
    });
    setOwnershipCompany(resultArr);
    let totalPercentage = resultArr?.reduce((sum, item) => {
      let percentage = 0;
      if (item.ownershipID.ownership_indID) {
        percentage = item.ownershipID.ownership_indID.percentage_of_shares_held;
      } else if (item.ownershipID.ownership_compID) {
        percentage = item.ownershipID.ownership_compID.percentage_of_shares_held;
      }
      return parseFloat((sum + percentage).toFixed(2));
    }, 0);
    settotalPercentage(totalPercentage);

    const companyStatus = async () => {
      let dataval = await ownershipDraft({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      let ownership_ind = dataval?.data?.ownership_ind || [];
      let ownership_com = dataval?.data?.ownership_com || [];
      let respData = ownership_ind.concat(ownership_com);
      let tempArr = [];
      let draft_ids_company = [];
      let draft_ids_individual = [];
      let ids_individual = [];
      let ids_company = [];
      let main_ids_ind = [];
      let main_ids_comp = [];
      for (let i = 0; i < respData.length; i++) {
        if (respData[i]?.ownership_compID_id)
          draft_ids_company.push(respData[i]?.ownership_compID_id);
        if (respData[i]?.ownership_indID_id)
          draft_ids_individual.push(respData[i]?.ownership_indID_id);
        tempArr.push(respData[i]);
      }
      currentEditingCompany?.ownershipCompany?.forEach(function (obj) {
        if (obj?.ownershipID?.ownership_indID?.is_deleted == 0 && obj?.ownershipID?.ownership_compID == null) {
          if (obj?.ownershipID?.ownership_indID?.ownership_indID) {
            ids_individual.push(obj?.ownershipID?.ownership_indID?.ownership_indID)
          }
        }
        else if (obj?.ownershipID?.ownership_compID?.is_deleted == 0 && obj?.ownershipID?.ownership_indID == null) {
          if (obj?.ownershipID?.ownership_compID?.ownership_compID) {
            ids_company.push(obj?.ownershipID?.ownership_compID?.ownership_compID)
          }
        }
      });
      ids_individual?.forEach(function (id) {
        if (!draft_ids_individual.includes(id))
          main_ids_ind.push(id)
      })
      ids_company?.forEach(function (id) {
        if (!draft_ids_company.includes(id))
          main_ids_comp.push(id)
      });
      currentEditingCompany?.ownershipCompany?.forEach(function (obj) {

        if (obj?.ownershipID?.ownership_compID?.is_deleted == 0) {
          if (main_ids_comp.includes(obj?.ownershipID?.ownership_compID?.ownership_compID)) {
            tempArr.push(obj?.ownershipID?.ownership_compID)
          }
        }
        if (obj?.ownershipID?.ownership_indID?.is_deleted == 0) {
          if (main_ids_ind.includes(obj?.ownershipID?.ownership_indID?.ownership_indID)) {
            tempArr.push(obj?.ownershipID?.ownership_indID)
          }
        }
      });
      setOwnershipCompanyDraft(tempArr)
      let totalPercentage = tempArr?.reduce((sum, item) => {
        let percentage = 0;
        percentage = item?.percentage_of_shares_held;
        return parseFloat((sum + percentage).toFixed(2));
      }, 0);
      settotalPercentage(totalPercentage);

    }
    companyStatus();
  }, [currentEditingCompany, data, dataChanged]);

  const modalHandle = (ownership_indID, edit = false) => {
    setEditOwnership(ownership_indID);
    setIsOpen(!isOpen);
    refetch();
  };


  if (isLoading)
    return (
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <LoadingIcon />
      </div>
    );
  function createArrayFromObjectDraft(object) {
    let otherData = [
      "type",
      "name",
      "company_name",
      "country",
      "percentage_of_shares_held",
    ];
    let icons = {
      type: <TypeIcon />,
      name: <NameIcon />,
      company_name: <NameIcon />,
      country: <NationalityIcon />,
      percentage_of_shares_held: <ShareIcon />,
    };
    let newObject = {
      "ownership_compID": object.ownership_comp_draftID || object.ownership_ind_draftID,
      "type": object.type,
      "name": object.company_name || object.name,
      "country": getCountryByCode(object.nationality),
      "percentage_of_shares_held": object.percentage_of_shares_held,
    }
    if (object.type == 'company') {
      newObject = {
        "ownership_compID": object.ownership_comp_draftID || object.ownership_ind_draftID,
        "type": object.type,
        "company_name": object.company_name || object.name,
        "country": getCountryByCode(object.nationality),
        "percentage_of_shares_held": object.percentage_of_shares_held,
      }
    }


    let data = [];

    for (let key in newObject) {
      if (otherData.includes(key)) {
        if (key === "percentage_of_shares_held") {
          data.push({ [key]: newObject[key] + " %", icon: icons[key] });
        } else {
          data.push({ [key]: newObject[key], icon: icons[key] });
        }
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]}
        icon={item[1][1]}
      />
    ));
    return html;
  }
  function createArrayFromObject(object) {

    let otherData = [
      "type",
      "name",
      "company_name",
      "nationality",
      "percentage_of_shares_held",
    ];
    let icons = {
      type: <TypeIcon />,
      name: <NameIcon />,
      company_name: <NameIcon />,
      nationality: <NationalityIcon />,
      percentage_of_shares_held: <ShareIcon />,
    };

    const newObject = {
      "ownership_compID": object.ownership_compID,
      "type": object.type,
      "company_name": object.company_name || object.name,
      "nationality": getCountryByCode(object.nationality),
      "percentage_of_shares_held": object.percentage_of_shares_held,
    }

    let data = [];

    for (let key in newObject) {
      if (otherData.includes(key)) {
        if (key === "percentage_of_shares_held") {
          data.push({ [key]: newObject[key] + " %", icon: icons[key] });
        } else {
          data.push({ [key]: newObject[key], icon: icons[key] });
        }
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]}
        icon={item[1][1]}
      />
    ));
    return html;
  }


  const handleNext = () => {
    if (totalPercentage === 0 || totalPercentage === 100) {
      onNext(3, "Authorized Signatory", "Details");
      return;
    }
    if (totalPercentage > 0 && totalPercentage < 100) {
      toggleModal();
      return;
    }
  }

  function handleDelete(companyID) {
    deleteOwnershipCompanyDetails({ companyID, token });
    toggleModal();
    refetch();
  }
  const handleSearchShow = () => {
    setShowSearch((prev) => !prev);
    setShowForm((prev) => !prev);
  };
  const handleFormShow = (companyData) => {
    if (selectedCompany || companyData) {
      setShowSearch(false);
      setShowForm(true);
      setShowAddCompany(false);
    }
  };
  const handleSearch = ({ searchTerm, countryCode }) => {
    if (searchTerm.length < 3) {
      setSearchResults([]);
    }
    if (searchTerm.length >= 3) {
      setCountryCodeSearch(countryCode);
      searchOnChange(searchTerm);
    }
  };
  const getSelectedCompany = (company) => {
    setSelectedCompany(company);
  };
  const updatepreVal = (selectedCountry, shareRef) => {
    setprevisousCountry(selectedCountry);
    setprevisousShare(shareRef);
  }
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.ownership_ind_draftID) {
      let dataval = await deleteDraftOwnership({
        data: deleteInfo?.ownership_ind_draftID,
      });
      if (dataval?.data == null) {
        alert("Ownership Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.ownership_comp_draftID) {
      let dataval = await deleteDraftCompany({
        data: deleteInfo?.ownership_comp_draftID,
      });

      if (dataval?.data == null) {
        alert("Ownership Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.ownership_indID) {
      let res = await updateOwnershipIndividual({
        data: { is_deleted: 1 },
        ownership_indId: deleteInfo?.ownership_indID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Ownership Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.ownership_compID) {
      let res = await updateOwnershipCompanyDetails({
        data: { is_deleted: 1 },
        ownership_compId: deleteInfo?.ownership_compID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Ownership Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    }
  }
  return (
    <div className="mt-5 mr-20">
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-10">
          <div className="fixed inset-0  bg-opacity-10 backdrop-blur-sm"></div>
          <img
            className="fixed opacity-10 w-full "
            src={bgImage}
            alt="bg"
            onClick={() => setShowModal(false)}
          />
          <div className="bg-white text-center flex flex-col items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg p-4 w-1/4">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-0 right-0 p-4 text-[#FB512D] flex align-center gap-1 z-10"
            >
              <Close />
            </button>
            <img src={CreditNotice} className="w-1/2 mx-auto mb-3" alt="Credit Notice" />
            <h3 className="text-secondarytwo text-left text-f20 font-semibold mb-2">
              Action Required!
            </h3>
            <p className="text-secondary text-f14 mb-3 w-3/4"><b>Data integrity issue:</b> ownership sum does not equal 100%.<br /> Pie chart generation requires complete data set.</p>
            <div className="mt-5 flex gap-4">
              <button
                className="px-4 py-2 text-white bg-red-600 rounded"
                onClick={() => {
                  onSkip(3, "Authorized Signatory", "Details");
                }}
              >
                Skip
              </button>
              <button
                className="px-4 py-2 text-black bg-blue-600 rounded hover:bg-blue-700"
                onClick={() => {
                  toggleModal();
                }}
              >
                Add Ownership
              </button>
            </div>
            <div className="flex justify-between text-secondary items-center"></div>
          </div>
        </div>
      )}

      {isOpen && (
        <Modal modalHandle={modalHandle}>
          {showForm && (
            <>
              <AddNewOwner
                indOwnership={editOwnership}
                modalHandle={modalHandle}
                totalPercentage={totalPercentage}
                showForm={handleFormShow}
                onSearch={(selectedCountry, shareRef) => { updatepreVal(selectedCountry, shareRef); handleSearchShow() }}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                selectedCompanyName={selectedCompanyName}
                previsousCountry={previsousCountry}
                previsousShare={previsousShare}
                refetch={refetch}
                compRefetch={compRefetch}
                dataChanged={dataChanged}
                setDataChanged={setDataChanged}
              />
            </>)}
          {showSearch && (
            <>
              <div className="test2">
                <Search
                  onSearch={handleSearch}
                  results={searchResults}
                  isLoading={isLoadingSearch}
                  getSelectedCompany={getSelectedCompany}
                  setSelectedCompanyName={setSelectedCompanyName}
                  showForm={handleFormShow}
                  handleSearchShow={handleSearchShow}
                  handleAddNewCompany={handleAddNewCompany}
                  breadPrev="Add Ownership Business"
                  breadNext="Select Business"
                  searchLabel="Search your Business"
                  searchEmptyText="Search & Select your business"
                  error={error}
                  message={message}
                />
              </div>
            </>
          )}
          {showAddCompany && (
            <>
              <div className="test3">
                <AddCompanyName
                  handleAddNewCompany={handleAddNewCompany}
                  breadNext={"Add Business Name"}
                  breadPrev={"Select business"}
                  label={"Add Business Name"}
                  handleSelectedCompany={getSelectedCompany}
                  handleCompanySubmit={handleFormShow}
                />
              </div>

            </>
          )}
        </Modal>
      )}

      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Ownership Structure
      </h3>
      {/* <p>{JSON.stringify(currentEditingCompany?.company_status)}</p> */}

      <div className="border border-slate rounded-lg p-8 mb-6 z-0 relative">
        <AddButton
          text="Register a New Business Owner"
          buttonText="Add"
          onClick={() => totalPercentage === 100 ? alert("The total percentage of shares held is 100%. Try to edit the % before adding new") : modalHandle(null)}

        />
        <div className="grid grid-cols-2 gap-4">
          {
            OwnershipCompanyDraft?.map((item) => (
              <EditCard>
                <div className="statusSection">
                  {item?.status === "Verified" && (
                    <Verified />
                  )}
                  {item?.status === "Declined" && (
                    <Declined />
                  )}
                  {item?.status === "Skipped" && (
                    <Skipped />
                  )}
                  {(item?.status === "Requested" || item?.status === "raised" || item?.status === "pending") && (
                    <Requested />
                  )}
                </div>
                <div className="h-[16rem] overflow-y-auto relative  my-2">
                  {createArrayFromObjectDraft(
                    item
                  )}
                </div>
                <div className="actionseditDelete  gap-4">
                  {
                    (currentEditingCompany?.company_status !== "Verified" || (currentEditingCompany?.company_status === "Verified" && item?.type === "individual")) && (
                      <Button
                        onClick={() => modalHandle(item, true)}
                        classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                      >
                        <span>Edit Details</span>
                        <span>
                          <Pen />
                        </span>
                      </Button>
                    )
                  }
                  <Button
                    onClick={() => modalHandleDelete(item)}
                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                  >
                    <span>Delete</span>
                    <span>
                      <Delete />
                    </span>
                  </Button>
                </div>
              </EditCard>
            ))
          }
          {OwnershipCompanyDraft.length <= 0 && ownershipCompany?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {(item?.ownershipID?.ownership_indID?.status || item?.ownershipID?.ownership_compID?.status) === "Verified" && (
                  <Verified />
                )}
                {(item?.ownershipID?.ownership_indID?.status || item?.ownershipID?.ownership_compID?.status) === "Declined" && (
                  <Declined />
                )}
                {(item?.ownershipID?.ownership_indID?.status || item?.ownershipID?.ownership_compID?.status) === "Skipped" && (
                  <Skipped />
                )}
                {(item?.ownershipID?.ownership_indID?.status || item?.ownershipID?.ownership_compID?.status) === "Requested" || (item?.ownershipID?.ownership_indID?.status || item?.ownershipID?.ownership_compID?.status) === "raised" && (
                  <Requested />
                )}
              </div>
              <div className="h-[16rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(
                  item?.ownershipID?.ownership_indID ||
                  item?.ownershipID?.ownership_compID
                )}
              </div>
              <div className="actionseditDelete  gap-4">
                <Button
                  onClick={() =>
                    modalHandle(
                      item?.ownershipID?.ownership_indID ||
                      item?.ownershipID?.ownership_compID
                    )
                  }
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item?.ownershipID?.ownership_indID ||
                    item?.ownershipID?.ownership_compID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
        </div>
      </div>




      <BackNextButton
        onPrev={() => onPrev(1, "Tax Information", "Details")}
        onNext={handleNext}
        onSkip={() => onSkip(3, "Authorized Signatory", "Details")}
      />
    </div>
  );
};
